import { observable, reaction, action } from 'mobx';
import { ZipApi } from '../../lib/ZipApi';
import { directoryStore } from '../DirectoryStore';
import { ProductInstances } from '../../types/DataSyncItem';

/**
 * Shared store for product instances data that can be used by both
 * source and destination product stores to avoid duplicate API calls.
 */
export class ProductInstancesStore {
  @observable private _productInstancesLoading = false;
  @observable private _productInstances: ProductInstances[] = [];

  constructor() {
    reaction(() => directoryStore.trackerId, () => {
      this.fetchProductInstances();
    }, {fireImmediately: true});
  }

  @action
  public async fetchProductInstances(): Promise<void> {
    if (!directoryStore.trackerId) return;

    try {
      this._productInstances = [];
      this._productInstancesLoading = true;
      this._productInstances = await ZipApi.listProductInstances(directoryStore.trackerId!);
    } finally {
      this._productInstancesLoading = false;
    }
  }

  public get productInstances(): ProductInstances[] {
    return this._productInstances;
  }

  public get productInstancesLoading(): boolean {
    return this._productInstancesLoading;
  }
}
